// extracted by mini-css-extract-plugin
export default {"pill":"bfaqA fmngK SWF0h uy0ax K3Blx _8u2aZ _3CwZW xJNSz","pillWithoutIcon":"mwlII","pillIconBefore":"uSxpq","icon":"GpgRi"};